import { lazyNamed } from '@helpers/lazyNamed';
import {
  FORGOT_PASSWORD_ROUTE,
  GDPR_ACCESS_ROUTE,
  LOGIN_PAGE_ROUTE,
  MFA_ENFORCED_BY_COMPANY_ROUTE,
  OTP_PAGE_ROUTE,
  PASSWORD_RESET_ROUTE,
  REDIRECT_EXTERNAL_LOGIN_ROUTE,
} from '../../constants/routes';
import type { IRoute } from '../../interfaces/IRoutes';

const AuthPage = lazyNamed(() => import('../pages/AuthPage'), 'AuthPage');

export const UnauthenticatedAppRoutes: IRoute[] = [
  {
    path: LOGIN_PAGE_ROUTE,
    component: AuthPage,
    exact: true,
  },
  {
    path: FORGOT_PASSWORD_ROUTE,
    component: AuthPage,
    exact: true,
  },
  {
    path: PASSWORD_RESET_ROUTE,
    component: AuthPage,
    exact: true,
  },
  {
    path: OTP_PAGE_ROUTE,
    component: AuthPage,
    exact: true,
  },
  {
    path: GDPR_ACCESS_ROUTE,
    component: AuthPage,
  },
  {
    path: MFA_ENFORCED_BY_COMPANY_ROUTE,
    component: AuthPage,
    exact: true,
  },
  {
    path: REDIRECT_EXTERNAL_LOGIN_ROUTE,
    component: AuthPage,
    exact: true,
  },
];
